import { MerchantCode } from "@/enums/merchantCode.enum";

export interface MerchantInfo {
  phoneNumber: string;
  phoneNumberShow: string;
  customerTime?: string;
  customerTimeShow?: string;
}

export const MerchantConfigs: Record<string, MerchantInfo> = {
  [MerchantCode.LIANG_HUA_PAI]: {
    phoneNumber: "4000020061",
    phoneNumberShow: "400-002-0061",
  },
  [MerchantCode.JING_YIN_RONG]: {
    phoneNumber: "95118",
    phoneNumberShow: "95118",
  },
  [MerchantCode.REN_PIN]: {
    phoneNumber: "4000326802",
    phoneNumberShow: "400-032-6802",
  },
  [MerchantCode.HENG_XIAO_HUA]: {
    phoneNumber: "4000456600",
    phoneNumberShow: "4000-456-600",
  },
  [MerchantCode.NI_WO_DAI]: {
    phoneNumber: "4006808888",
    phoneNumberShow: "400-680-8888",
    customerTime: "时间：工作日8:00-21:00|节假日9:00-19:00",
  },
  [MerchantCode.LIAN_RONG]: {
    phoneNumber: "4000828285",
    phoneNumberShow: "400-082-8285",
  },
  [MerchantCode.LE_XIANG_RONG]: {
    phoneNumber: "4000698816",
    phoneNumberShow: "4000-698-816",
    customerTime: "客服时间：工作日08:00-20:00",
  },
  [MerchantCode.WEI_XIANG_HUA]: {
    phoneNumber: "4000606039",
    phoneNumberShow: "400-060-6039",
    customerTime: "客服时间：周一至周五 9:00-18:00",
  },
  [MerchantCode.HE_XIAO_BAO]: {
    phoneNumber: "4008032907",
    phoneNumberShow: "400-803-2907",
    customerTime: "客服时间：9:30-18:00",
  },
  [MerchantCode.LU_YOU_XUAN]: {
    phoneNumber: "4000015888",
    phoneNumberShow: "400-001-5888",
    customerTime: "客服时间：工作日 9:00-18:00",
  },
  [MerchantCode.KA_NIU]: {
    phoneNumber: "4006988018",
    phoneNumberShow: "400-698-8018",
    customerTime: "客服时间：9:00-18:00",
  },
  [MerchantCode.YUAN_XIAO_HUA]: {
    phoneNumber: "4008553305",
    phoneNumberShow: "400-855-3305",
    customerTime: "客服时间：9:00-18:00",
  },
  [MerchantCode.YUAN_XIAO_HUA_MALL]: {
    phoneNumber: "4008553305",
    phoneNumberShow: "400-855-3305",
    customerTime: "客服时间：9:00-18:00",
  },
  [MerchantCode.HENG_XIN]: {
    phoneNumber: "4008032108",
    phoneNumberShow: "400-803-2108",
    customerTime: "客服时间：工作日09:00~20:00",
  },
  [MerchantCode.FEN_ZHUAN]: {
    phoneNumber: "4000880935",
    phoneNumberShow: "400-088-0935",
    customerTime: "客服时间：工作日8:00~22:00",
  },
  [MerchantCode.KE_DAI_QIAN_BAO]: {
    phoneNumber: "4000880903",
    phoneNumberShow: "400-088-0903",
    customerTime: "客服时间：工作日10:00~18:00",
  },
  [MerchantCode.KE_XIANG_DAI]: {
    phoneNumber: "4000880903",
    phoneNumberShow: "400-088-0903",
    customerTime: "客服时间：工作日10:00~18:00",
  },
  [MerchantCode.ZHI_LIAN_RONG]: {
    phoneNumber: "4008508926",
    phoneNumberShow: "400-850-8926",
    customerTime: "客服时间：工作日9:00~19:00",
  },
  [MerchantCode.MAI_BEI]: {
    phoneNumber: "4006531881",
    phoneNumberShow: "400-653-1881",
    customerTime: "客服时间：工作日9:00-22:00",
  },
  [MerchantCode.MEI_XIN]: {
    phoneNumber: "4001662193",
    phoneNumberShow: "400-1662-193",
    customerTime: "客服时间：工作日09:00~18:00",
  },
  [MerchantCode.LIANG_HUA_PAI_HALF]: {
    phoneNumber: "4006660873",
    phoneNumberShow: "400-666-0873",
    customerTime: "客服时间：工作日8:00-20:00",
  },
  [MerchantCode.SHAN_JIE_HUA]: {
    phoneNumber: "4009980380",
    phoneNumberShow: "400-998-0380",
    customerTime: "客服时间：工作日9:00-21:00",
  },
  [MerchantCode.JING_XIANG_GOU]: {
    phoneNumber: "4008989689",
    phoneNumberShow: "400-898-9689",
    customerTime: "客服时间：工作日9:00~18:00",
  },
  [MerchantCode.DUO_JIN_YOU_XUAN]: {
    phoneNumber: "4000345066",
    phoneNumberShow: "400-0345-066",
    customerTime: "客服时间：工作日8:00~21:00",
  },
};
/**
 * 资方信息已改为通过接口 /app/find-semi-process-list 动态获取
 * 数据存储在 store/home.ts -> merchantConfigMap
 * 字段映射：supportLine -> phoneNumberShow, supportLine去横线 -> phoneNumber, supportLineTime -> customerTime
 */

// 默认配置（兜底值，接口未返回对应资方时使用）
export const DefaultMerchantInfo: MerchantInfo = {
  phoneNumber: "4001855661",
  phoneNumberShow: "400-185-5661",
  customerTime: "客服时间：工作日9:00-12:00，13:30-19:00",
  customerTimeShow: "工作日9:00-12:00，13:30-19:00",
};
